module.exports = __webpack_public_path__ + "static/media/img4.8f7de4a0.jpg";